@file:OptIn(ExperimentalFoundationApi::class, ExperimentalComposeUiApi::class)

package demos.coil

import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.gestures.*
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.rememberLazyListState
//import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Slider
import androidx.compose.material.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.blur
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.pointer.PointerEventType
import androidx.compose.ui.input.pointer.onPointerEvent
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.launch
import org.jetbrains.skiko.SkikoPointerEvent

const val PAGER = "aljfalskdjfl;jwae;ogijeraio"


@Composable
fun ImageScaleType() {


//    HorizontalPager(
//        pageCount = 3,
//    ) {
//        Box(Modifier.padding(16.dp).fillMaxSize().background(Color.Yellow))
//    }
    var c by remember { mutableStateOf(Offset.Zero) }
    var d by remember { mutableStateOf(Offset.Zero) }

    Box {
        Column {
            Text("change = $c")
            Text("dragAmou = $d")
        }

        val state = rememberLazyListState()
//        state.dispatchRawDelta()
//        state.animateScrollBy()

//        LazyColumn (
//            Modifier
//                .blur(10.dp)
//                .graphicsLayer {
//
//                }
//                .fillMaxSize(),
//            state = state,
////            verticalAlignment = Alignment.CenterVertically,
//            horizontalAlignment = Alignment.CenterHorizontally,
//        ) {
//
//            items(100) {
//                var switch by remember { mutableStateOf(false) }
//                Box(Modifier.clickable { switch = !switch }.padding(8.dp).background(if (switch) Color.Yellow else Color.Cyan, RoundedCornerShape(10.dp)).size(100.dp))
//            }
//
//        }

        val scrollState = rememberLazyListState()
        val coroutineScope = rememberCoroutineScope()
        LazyColumn(
            state = scrollState,
            modifier = Modifier
                .fillMaxSize()
                .onPointerEvent(PointerEventType.Scroll) {
                    coroutineScope.launch {
                        scrollState.scrollBy((it.nativeEvent as SkikoPointerEvent).deltaY.toFloat())
                    }
                }
//                .draggable(
//                    orientation = Orientation.Vertical,
//                    state = rememberDraggableState { delta ->
//                        coroutineScope.launch {
//                            scrollState.scrollBy(-delta)
//                        }
//                    },
//                )
            ,
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
//            items(100) {
//                Text("Test Test Test Test $it")
//            }
            item {

            var value by remember { mutableStateOf(0f) }
                Slider(
                    value = value,
                    onValueChange = {
                        value = it
                    },
                    modifier = Modifier.fillMaxWidth().height(50.dp)
                )
            }
            items(100) {
                var switch by remember { mutableStateOf(false) }
                Box(
                    Modifier.clickable { switch = !switch }.padding(8.dp)
                        .background(if (switch) Color.Yellow else Color.Red, RoundedCornerShape(10.dp)).size(100.dp)
                )
            }
        }


//        Box(Modifier
//            .fillMaxSize()
//            .pointerInput("Unit") {
//                detectDragGestures { change, dragAmount ->
//                    c = change.position
//                    d = dragAmount
//                }
//            })
    }


}